export const createFirstHxReportHtml = (
  htmlContent,
  patientID,
  customLogoPath = null,
  siteName = null,
) => {
  const logoPath = customLogoPath || `${window.location.origin}/assets/images/FirstHx_symbol_colour.jpg`;
  const reportTitle = patientID ? `Patient Report - ${patientID}` : 'Patient Report';
  const currentDate = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
  const currentYear = new Date().getFullYear();

  return `
    <div class="pdf-container">
      <div class="header">
        <div class="logo-container">
          <img class="logo" src="${logoPath}" alt="FirstHx Logo">
          <div class="title-container">
            <span class="company-name">${siteName || 'FirstHx'}</span>
            <span class="report-title">${reportTitle}</span>
          </div>
        </div>
      </div>

      <div class="content">
        <div class="report-content">
          ${htmlContent || ''}
        </div>
      </div>
      
      <div class="footer">
        <div class="footer-logo-container">
          <img class="footer-logo" src="${logoPath}" alt="FirstHx Logo">
          <span>Generated on ${currentDate}</span>
        </div>
        <span>© ${currentYear} ${siteName || 'FirstHx'}. All rights reserved.</span>
      </div>
    </div>
  `;
};

export const firstHxDocumentStyles = `
  body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
    line-height: 1.2;
    color: #333;
    margin: 0;
    padding: 0;
    background-color: #fff;
    width: 100%;
  }
  .pdf-container {
    width: 100%;
    max-width: 900px;
    margin: 0 auto;
    padding: 40px 50px;
    box-sizing: border-box;
    background-color: #fff;
  }
  .header {
    display: flex;
    align-items: flex-start;
    margin-bottom: 48px;
  }
  .logo-container {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
  }
  .title-container {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .logo {
    height: auto;
    max-width: 100px;
    object-fit: contain;
  }
  .company-name {
    color: #1976d2;
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 0.25px;
  }
  .report-title {
    color: #1976d2;
    font-size: 24px;
    opacity: 0.9;
  }
  .content {
    background: white;
    padding: 0;
  }
  .report-content {
    font-size: 16px;
    line-height: 1.0;
    color: #333;
  }
  .footer {
    margin-top: 48px;
    padding-top: 16px;
    border-top: 1px solid #e0e0e0;
    font-size: 13px;
    color: #666;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .footer-logo-container {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .footer-logo {
    max-width: 40px;
    height: auto;
    opacity: 0.7;
  }
  img {
    max-width: 100%;
  }
`;
